import installationInstructions from './installationInstructions';

const ariaOmContent = {
  installationInstructions
}

export { ariaOmContent };